import { render, staticRenderFns } from "./DeleteGroupDialog.vue?vue&type=template&id=598307a5"
import script from "./DeleteGroupDialog.vue?vue&type=script&lang=js"
export * from "./DeleteGroupDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports